import { styled } from '@nextiva/next-ui-components';
import { pxToRem } from 'utils/pxToRemConverter';
import colors from 'styles/application/_base/_variables.scss';

export const RevealCardStyles = styled('div')`
  .MuiFormLabel-root {
    margin-bottom: 0;
    display: block;
    font-weight: 700;
  }

  .header {
    margin: 36px 0 5px;
    font-size: ${pxToRem('16px')};
    font-weight: 900;
    line-height: 24px;
    color: ${colors.primaryFontColor};
  }

  .toggle-button {
    display: flex;
    align-items: center;
    width: 100%;
    border: none;
    background-color: transparent;
    cursor: pointer;
    font-size: ${pxToRem('16px')};
    font-weight: 900;
    line-height: 24px;
    letter-spacing: 0.4px;
  }

  .header-group {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .helper-text {
    font-size: ${pxToRem('16px')};
    font-weight: 500;
    text-align: left;
    letter-spacing: 0.24px;
    letter-spacing: 0.4px;
    color: ${colors.secondaryColor};
  }

  .close-button {
    bottom: 0;
    display: flex;
    align-items: center;
    margin: 43px 0 0 0;
    color: ${colors.secondaryColor};
    font-size: ${pxToRem('10px')};
    font-weight: 800;
    letter-spacing: 0.25px;
    border: none;
    background-color: white;
    cursor: pointer;

    & > div {
      margin: 0 12px 0 0;
    }
  }

  .svg-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
    border: none;
    background-color: transparent;
    cursor: pointer;
    padding: 12px 12px 12px 0;
    margin: -12px -12px -12px 0; // this rule combined with the padding above increases the clickable area without shifting the layout in the UI
  }

  .footer {
    margin-top: 40px;
    border-bottom: 1px solid ${colors.dividerColor};
  }
`;
